// ---------- the alphabet in play ----------
// The registry lives in shared/ and takes an id, because the admin has to convert with an
// alphabet the operator picked in a form, not with "the current one". The game does have a
// current one — the loaded puzzle's — and this is where that state is read, once.

import { alphabetById, codeOrder as orderOf, codeRank as rankOf } from '../shared/alphabets';
import type { Alphabet } from '../shared/alphabets';
import { S } from './state';

export function alphabet(): Alphabet {
  return alphabetById(S.alphabetId);
}

export function codeOrder(a: Alphabet = alphabet()): readonly number[] {
  return orderOf(a);
}

export function codeRank(a: Alphabet = alphabet()): readonly number[] {
  return rankOf(a);
}
